<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <div class="custom-control custom-checkbox custom-control-inline">
        <input name="displayOnlyOurs" id="displayOnlyOurs" type="checkbox" class="custom-control-input" value="displayOnlyOurs" [(ngModel)]="displayOnlyOurs" (ngModelChange)="saveSettings()">
        <label for="displayOnlyOurs" class="custom-control-label">&nbsp;Display only ours</label>
      </div>
      <div class="custom-control custom-checkbox custom-control-inline">
        <input name="hideBranches" id="hideBranches" type="checkbox" class="custom-control-input" value="hideBranches" [(ngModel)]="hideBranches" (ngModelChange)="saveSettings()">
        <label for="hideBranches" class="custom-control-label">&nbsp;Hide branches</label>
      </div>

      @for (displaySetting of displaySettings; track displaySetting) {
        <div class="custom-control custom-checkbox custom-control-inline">
          <input name="display-{{displaySetting.key}}" id="display-{{displaySetting.key}}" type="checkbox" class="custom-control-input" [(ngModel)]="displaySetting.display" (ngModelChange)="saveSettings()">
          <label for="display-{{displaySetting.key}}" class="custom-control-label">&nbsp;Display {{displaySetting.name}}</label>
        </div>
      }
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <table class="table table-sm table-hover">
        <thead>
          <tr>
            <th>Project</th>
            <th>Branch</th>
            <th>ours</th>
            <th>mirror</th>
            <th>pullSuccess</th>
            @for (opt of getActiveDisplayValues(); track opt) {
              <th>{{opt.name}}</th>
            }
          </tr>
        </thead>
        <tbody>
          @for (row of getFilteredRows(); track row) {
            <tr>
              <td>{{row.config.relativeUrl}}</td>
              <td>{{row.config.branch}}</td>
              <td>{{row.config.ours}}</td>
              <td>{{row.config.mirror}}</td>
              <td>{{row.result.pullSuccess}}</td>
              @for (opt of getActiveDisplayValues(); track opt) {
                <td>{{getMetric(row, opt.key)}}</td>
              }
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</div>
